import styled from 'styled-components';
import BasketPriceDetails from './BasketPriceDetailsTemplate';
import { rem } from 'polished';

export const BasketPriceDetailsStyled = styled(BasketPriceDetails)`
    margin: ${rem(30)} ${rem(10)} 0 ${rem(10)};

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(20)} 0;

        .titleContainer {
            display: flex;

            .sectionNumber,
            .title {
                font-size: ${rem('18px')};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                text-transform: lowercase;
                line-height: 1.4;

                &:first-letter {
                    text-transform: capitalize;
                }
            }

            .sectionNumber {
                margin-right: ${rem('10px')};
            }
        }
        .isOpen,
        .isClose {
            svg {
                width: ${rem('40px')} !important;
                height: ${rem(14)} !important;
                margin-right: unset !important;
            }
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
